import React, { Component } from "react";
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Col, Row, Button, Label } from "reactstrap";
import { Checkbox, CheckboxGroup, Form, Field } from "@availity/form";
import '@availity/yup';
import * as yup from 'yup';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import { DateField } from '@availity/date';
import awardeestore from '../stores/awardeestore';
import CustomProgressBar from "../../Common/components/CustomProgressBar";
import AllAcknowledgements from "./AllAcknowledgements";

@observer
export default class Acknowledgements extends Component {

	constructor(props) {
		super(props);

			this.state = {
				redirectTodocuments: false,
				redirectToReviewAndSubmit: false
			}

		if (awardeestore.getAwardeeHousingPageStatus('#acknowledgements') !== 'stepwizard-step active') {
			awardeestore.setAwardeeHousingPageStatus('#acknowledgements', 'active');
		}

		if(window.performance) {
			if(performance.navigation.type == 1) {
				awardeestore.resetAwardeeHousingPageStatus();
				window.location.href = '#';
			}
		}
	}

	componentDidMount() {
		window.onpopstate = () => {
			this.props.history.go(1);
		}
	}

    submit = () => {
		awardeestore.completedSteps.acknowledgements = true;
		this.setState({ redirectToReviewAndSubmit: true });
	}

    goBack = () => {
		this.setState({ redirectTodocuments: true });
	}

	setConsentDate = (value)  =>{
		awardeestore.setConsentDate(value)
	}

	setConsentTime = (event)  =>{
		const { value } = event.target;
		awardeestore.setTimeConsent(value)
	}

    render() {
        const { redirectToReviewAndSubmit, redirectTodocuments } = this.state;
		const { userAgent } = navigator;

        if (redirectToReviewAndSubmit) {
			return <Redirect to='/reviewAndSubmit' />
		}

		if (redirectTodocuments) {
			return <Redirect to="/documents" />
		}

        const {
			awardeeHousingPages, allAcknowledgements: predefinedAllAcknowledgements, acknowledgementInfo
		} = awardeestore;
		const {consentDate, consentTime} = acknowledgementInfo;
        const{validationObj, initialValueObj} = awardeestore.getIndividualInititalValues();

        return (
            <div className='border-form'>
					<CustomProgressBar pages={awardeeHousingPages} />

					<small className='required-fields'>*required</small>
					<div className='spacer-48' />
					<h2 className='poppinsH2'>
                        Acknowledgements
					</h2>
					<div className='spacer-28' />
                    <Form
						initialValues={
							{
								...initialValueObj,
								consentDateField: consentDate,
								consentTimeField: consentTime
							}
						}
						onSubmit={this.submit}
						validationSchema={yup.object().shape(
							{
								...validationObj,
								consentDateField: yup.date()
									.max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
									.min(moment().subtract(15, 'days').format('MM/DD/YYYY'), 'Date must be within the last 15 days')
									.required('Enrollee Consent Date is required')
									.typeError('Invalid Date'),
								consentTimeField: yup.string().required('Time Consent is required')
							}
						)}
					>
                        <AllAcknowledgements />
						<Row className="mt-5">	
							<Col sm="3">
								<DateField
									id="consentDate"
									name="consentDateField"
									label="Date Consent Received*"
									className="straighten-borders"
									value={consentDate}
									onChange={this.setConsentDate}
									datePickerProps={{
										autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
									}}
									placeholder='MM/DD/YYYY'
									max={moment().format('MM/DD/YYYY')}
									min={moment().subtract(15, 'days').format('MM/DD/YYYY')}
							/>
							</Col>
							<Col sm="4">
								<Label className="label-font" htmlFor="consentTime">
									Time Consent Received*
								</Label>
								<Field
									type="time"
									id="consentTime"
									name="consentTimeField"
									className="straighten-borders"
									value={consentTime}
									onChange={this.setConsentTime}
								/>
							</Col>
						</Row>
						<Button type="button" color={"primary"} className={'btn btn-primary straighten-borders buttonBack'} onClick={this.goBack}>
							Back
						</Button>
						<Button type="submit" color={"primary"} className={'btn btn-primary awardeeNextBtn mb-50'}>
							Next
						</Button>
                    </Form>
            </div>
        );
    }
}

Acknowledgements.propTypes = {
	history: PropTypes.object
}